import * as yup from 'yup';
import { forgotPassword as TEXT } from 'locales/en';

const schema = yup.object().shape({
  email: yup
    .string()
    .email(TEXT.errors.email.invalid)
    .required(TEXT.errors.email.required),
});

export default schema;
